export default __webpack_public_path__ + "static/logo-3646b4a64adaed0dfc16ad0fbe6acb66.svg";